import {FormHelperText, InputAdornment} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const timestampHelperStyles = {
	userSelect: 'none',
	margin: 'auto',
};

const DAY = 24 * 3600 * 1000;
const WEEK = DAY * 7;
const MONTH = DAY * 30;

export function TimestampHelperButtons(props) {
	const onHelperClicked = (interval) => {
		switch (interval) {
		case 'Now':
			return props.onChange(`${Date.now()}`);
		case 'D':
			return props.onChange(`${Date.now() - DAY}`);
		case 'W':
			return props.onChange(`${Date.now() - WEEK}`);
		case 'M':
			return props.onChange(`${Date.now() - MONTH}`);
		}
	};

	if (props.label === 'end_timestamp' || props.label === 'timestamp') {
		return (
			<InputAdornment position="end" style={{ cursor: 'pointer', height: '100%'}}>
				<FormHelperText className="timestamp-helper" style={timestampHelperStyles} onClick={() => onHelperClicked('Now')}>Now</FormHelperText>
			</InputAdornment>
		);
	}

	if (props.label === 'start_timestamp') {
		return (
			<InputAdornment position="end" style={{ cursor: 'pointer', display: 'flex', gap: '4px', height: '100%'}}>
				{
					['D', 'W', 'M'].map(interval =>
						<FormHelperText key={interval} className="timestamp-helper" style={timestampHelperStyles} onClick={() => onHelperClicked(interval)}>{interval}</FormHelperText>)
				}
			</InputAdornment>
		);
	}

	return null;
}

TimestampHelperButtons.propTypes = {
	label: PropTypes.string,
	onChange: PropTypes.func,
};